// extracted by mini-css-extract-plugin
export default {"heading":"Transactions_heading__xU8xd"};